<template>
  <div
    id="buyModal"
    tabindex="-1"
    ref="buyModal"
    role="dialog"
    class="modal fade text-left"
    style="display: none"
    aria-hidden="true"
  >
    <div role="document" class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- Заголовок модала -->
        <div class="modal-header">
          <strong class="modal-title">Купить подписку</strong>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
            @click="closeModal"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <!-- Тело модала -->
        <div class="modal-body">
          <!-- Выбор способа оплаты (перемещено наверх) -->
          <div class="payment-selection-top">
            <label class="payment-label">Выберите способ оплаты:</label>

            <div class="payment-methods">
              <label class="payment-option" :class="{ selected: paymentMethod === 'yoomoney' }">
                <input
                  type="radio"
                  name="payment"
                  value="yoomoney"
                  v-model="paymentMethod"
                />
                <div class="payment-content">
                  <span class="payment-flag payment-flag-ru">RU</span>
                  <div class="payment-text">
                    <span class="payment-name">ЮMoney</span>
                    <span class="payment-desc">Любое количество дней</span>
                  </div>
                </div>
              </label>

              <label class="payment-option" :class="{ selected: paymentMethod === 'worldwide' }">
                <input
                  type="radio"
                  name="payment"
                  value="worldwide"
                  v-model="paymentMethod"
                />
                <div class="payment-content">
                  <span class="payment-flag payment-flag-ww">WW</span>
                  <div class="payment-text">
                    <span class="payment-name">Worldwide</span>
                    <span class="payment-desc">FunPay, Oplata.info</span>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <!-- Выбор количества дней (только для ЮMoney) -->
          <div class="days-selector" v-if="paymentMethod === 'yoomoney'">
            <label class="form-label">Выберите количество дней:</label>

            <!-- Слайдер -->
            <div class="slider-container">
              <input
                type="range"
                min="1"
                max="365"
                v-model.number="selectedDays"
                class="custom-slider"
                @input="onSliderChange"
              />
              <div class="slider-labels">
                <span>1</span>
                <span>365</span>
              </div>
            </div>

            <!-- Кастомный числовой input с большими кнопками -->
            <div class="custom-numeric-input">
              <button
                type="button"
                class="control-btn"
                @click="decrementDays"
                :disabled="selectedDays <= 1"
              >
                −
              </button>
              <input
                type="number"
                v-model.number="selectedDays"
                @input="onInputChange"
                min="1"
                max="365"
                class="days-input"
              />
              <button
                type="button"
                class="control-btn"
                @click="incrementDays"
                :disabled="selectedDays >= 365"
              >
                +
              </button>
            </div>
          </div>

          <!-- Выбор провайдера для Worldwide -->
          <div class="worldwide-section" v-if="paymentMethod === 'worldwide'">
            <label class="form-label">Выберите провайдера:</label>

            <div class="provider-selector">
              <label class="provider-option" :class="{ selected: worldwideProvider === 'funpay' }">
                <input
                  type="radio"
                  name="provider"
                  value="funpay"
                  v-model="worldwideProvider"
                />
                <span class="provider-name">FunPay</span>
              </label>

              <label class="provider-option" :class="{ selected: worldwideProvider === 'oplata' }">
                <input
                  type="radio"
                  name="provider"
                  value="oplata"
                  v-model="worldwideProvider"
                />
                <span class="provider-name">Oplata.info</span>
              </label>
            </div>

            <!-- Пакеты FunPay -->
            <div class="package-section" v-if="worldwideProvider === 'funpay'">
              <label class="form-label">Выберите готовый пакет:</label>

              <div class="package-grid">
                <a
                  v-for="pkg in funpayPackages"
                  :key="pkg.id"
                  :href="global.funpay[pkg.storeKey].link"
                  target="_blank"
                  :class="['package-card', { 'package-popular': pkg.popular }]"
                >
                  <div v-if="pkg.popular" class="package-badge">Популярно</div>
                  <div class="package-name">{{ pkg.name }}</div>
                  <div class="package-price">{{ global.funpay[pkg.storeKey].price }} ₽</div>
                </a>
              </div>
            </div>

            <!-- Пакеты Oplata.info -->
            <div class="package-section" v-if="worldwideProvider === 'oplata'">
              <label class="form-label">Выберите готовый пакет:</label>

              <div class="package-grid">
                <a
                  v-for="pkg in oplataPackages"
                  :key="pkg.id"
                  :href="global.shop[pkg.storeKey].link"
                  target="_blank"
                  :class="['package-card', { 'package-popular': pkg.popular }]"
                >
                  <div v-if="pkg.popular" class="package-badge">Популярно</div>
                  <div class="package-name">{{ pkg.name }}</div>
                  <div class="package-price">{{ global.shop[pkg.storeKey].price }} ₽</div>
                </a>
              </div>
            </div>
          </div>

          <!-- Информация о скидках и ценах (только для ЮMoney) -->
          <div class="price-info" v-if="paymentMethod === 'yoomoney'">
            <table class="table">
              <tbody>
                <tr v-if="wholesaleDiscount > 0">
                  <td>Скидка за опт:</td>
                  <td style="text-align: right">{{ wholesaleDiscount }} ₽</td>
                </tr>
                <tr v-if="renewalDiscount > 0">
                  <td>Скидка за оплату более чем на месяц:</td>
                  <td style="text-align: right">{{ renewalDiscount }} ₽</td>
                </tr>
                <tr>
                  <td><strong>Финальная цена:</strong></td>
                  <td style="text-align: right">
                    <span class="final-price-animated" :key="finalPrice">
                      {{ finalPrice }} ₽
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Badge с экономией (показывается только если есть скидки) -->
            <div v-if="totalSavings > 0" class="savings-badge-container">
              <span class="badge badge-success savings-badge">
                Вы экономите {{ totalSavings }} ₽
              </span>
            </div>
          </div>
        </div>

        <!-- Футер с кнопкой оплаты (только для ЮMoney) -->
        <div class="modal-footer" v-if="paymentMethod === 'yoomoney'">
          <button
            type="button"
            class="btn btn-primary btn-block btn-pay"
            @click="processPay"
          >
            Оплатить {{ finalPrice }} ₽
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*global Messenger*/
/*eslint no-undef: "error"*/

import { mapGetters } from 'vuex';

// Константы для расчета цен (из profileComponent.vue)
const OPTIONS = {
  cost: 21.6,
  oneDayPrice: 59,
  weeklyDiscount: 9.3,
  wholesaleMinDays: 7,
  wholesaleDiscount: 1.2,
  wholesaleMaxDays: 35,
  renewalDiscountEnabled: true,
  renewalMinDays: 29,
  renewalDiscount: 9.3,
  renewalCount: 3,
  minBuyDays: 1,
  maxBuyDays: 365,
};

// Функция расчета цен (из profileComponent.vue)
const GetSubscriptionPrice = (_days) => {
  let count = Math.floor(_days);
  let actual_price = count * OPTIONS.cost;
  if (isNaN(actual_price)) actual_price = 0;
  let discount = 0;
  let renewal_discount = 0;
  if (count < OPTIONS.minBuyDays || count > OPTIONS.maxBuyDays) return null;

  if (count < OPTIONS.wholesaleMinDays) {
    actual_price = OPTIONS.oneDayPrice * count;
    let weekly_discount =
      (actual_price / 100) *
      (OPTIONS.wholesaleMinDays - (OPTIONS.wholesaleMinDays - (count - 1))) *
      OPTIONS.weeklyDiscount;
    actual_price -= weekly_discount;
  }

  if (count > OPTIONS.wholesaleMinDays) {
    discount =
      (actual_price / 100) *
      OPTIONS.wholesaleDiscount *
      Math.min(OPTIONS.wholesaleMaxDays, count);
    actual_price -= discount;
  }

  if (OPTIONS.renewalDiscountEnabled && count > OPTIONS.renewalMinDays) {
    renewal_discount =
      (actual_price / 100) * OPTIONS.renewalDiscount * OPTIONS.renewalCount;
    actual_price -= renewal_discount;
  }

  return {
    discount_wholesale: discount.toFixed(2),
    discount_more_mounth: renewal_discount.toFixed(2),
    final_price: actual_price.toFixed(2),
  };
};

export default {
  name: 'buyModal',
  data() {
    return {
      selectedDays: 30, // Начальное значение - 30 дней
      paymentMethod: 'yoomoney', // Выбранный способ оплаты по умолчанию
      worldwideProvider: 'oplata', // Провайдер по умолчанию для Worldwide
      funpayPackages: [
        { id: 0, name: '1 день', storeKey: 'day_1', popular: false },
        { id: 1, name: '7 дней', storeKey: 'day_7', popular: false },
        { id: 2, name: '30 дней', storeKey: 'day_30', popular: true },
        { id: 3, name: '90 дней', storeKey: 'day_90', popular: false },
      ],
      oplataPackages: [
        { id: 0, name: '1 день', storeKey: 'day_1', popular: false },
        { id: 1, name: '7 дней', storeKey: 'day_7', popular: false },
        { id: 2, name: '30 дней', storeKey: 'day_30', popular: true },
        { id: 3, name: '90 дней', storeKey: 'day_90', popular: false },
        { id: 4, name: '180 дней', storeKey: 'day_180', popular: false },
      ],
    };
  },
  computed: {
    ...mapGetters(['global']),

    // Скидка за опт
    wholesaleDiscount() {
      const price = GetSubscriptionPrice(this.selectedDays);
      return price ? parseFloat(price.discount_wholesale) : 0;
    },

    // Скидка за месяц
    renewalDiscount() {
      const price = GetSubscriptionPrice(this.selectedDays);
      return price ? parseFloat(price.discount_more_mounth) : 0;
    },

    // Финальная цена
    finalPrice() {
      const price = GetSubscriptionPrice(this.selectedDays);
      return price ? parseFloat(price.final_price).toFixed(2) : 0;
    },

    // Общая экономия (сумма всех скидок)
    totalSavings() {
      return (this.wholesaleDiscount + this.renewalDiscount).toFixed(2);
    },
  },
  methods: {
    // Обработчик изменения слайдера
    onSliderChange() {
      // Убеждаемся, что значение в пределах [1, 365]
      if (this.selectedDays < 1) this.selectedDays = 1;
      if (this.selectedDays > 365) this.selectedDays = 365;
    },

    // Обработчик изменения input
    onInputChange() {
      // Валидация при ручном вводе
      if (this.selectedDays < 1) this.selectedDays = 1;
      if (this.selectedDays > 365) this.selectedDays = 365;
      if (isNaN(this.selectedDays)) this.selectedDays = 30;
    },

    // Увеличить количество дней
    incrementDays() {
      if (this.selectedDays < 365) {
        this.selectedDays++;
      }
    },

    // Уменьшить количество дней
    decrementDays() {
      if (this.selectedDays > 1) {
        this.selectedDays--;
      }
    },

    // Закрытие модала
    closeModal() {
      // Сброс значений при закрытии
      this.selectedDays = 30;
      this.paymentMethod = 'yoomoney';
      this.worldwideProvider = 'funpay';
    },

    // Обработка оплаты (только для ЮMoney)
    processPay() {
      if (this.paymentMethod === 'yoomoney') {
        window.open(
          `/api/start_payment/cards/yandex/${this.selectedDays}`,
          '_blank'
        );
      }
    },
  },
  mounted() {
    // Подключаем Bootstrap обработчик закрытия модала
    $(this.$refs.buyModal).on('hidden.bs.modal', this.closeModal);
  },
};
</script>

<style lang="sass" scoped>
// Выбор способа оплаты сверху
.payment-selection-top
  margin-bottom: 32px

// Контейнер выбора дней
.days-selector
  margin-bottom: 24px

.form-label
  font-weight: 600
  margin-bottom: 12px
  display: block
  color: #979a9f

// Секция Worldwide
.worldwide-section
  margin-bottom: 24px

// Селектор провайдера
.provider-selector
  display: flex
  gap: 12px
  margin-bottom: 24px

.provider-option
  flex: 1
  position: relative
  display: flex
  align-items: center
  justify-content: center
  padding: 12px 16px
  background: #2d3035
  border: 2px solid #444951
  border-radius: 8px
  cursor: pointer
  transition: all 0.2s

  &:hover
    border-color: #868e96

  &.selected
    border-color: #379392
    background: rgba(55, 147, 146, 0.05)

  input[type="radio"]
    position: absolute
    opacity: 0
    width: 0
    height: 0

.provider-name
  color: #fff
  font-size: 15px
  font-weight: 500

// Секция с пакетами
.package-section
  margin-top: 24px

.package-grid
  display: grid
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr))
  gap: 12px
  margin-top: 16px

.package-card
  position: relative
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 20px 16px
  background: #2d3035
  border: 2px solid #444951
  border-radius: 8px
  text-decoration: none
  transition: all 0.2s
  min-height: 100px

  &:hover
    border-color: #379392
    background: rgba(55, 147, 146, 0.05)
    transform: translateY(-2px)
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3)

  &.package-popular
    border-color: #379392
    background: rgba(55, 147, 146, 0.1)

.package-badge
  position: absolute
  top: -8px
  right: 8px
  background: #379392
  color: #fff
  font-size: 10px
  font-weight: 600
  padding: 3px 8px
  border-radius: 10px
  text-transform: uppercase
  letter-spacing: 0.5px

.package-name
  color: #979a9f
  font-size: 13px
  font-weight: 500
  margin-bottom: 8px
  text-align: center

.package-price
  color: #fff
  font-size: 20px
  font-weight: 700
  text-align: center

// Контейнер слайдера
.slider-container
  margin: 16px 0
  position: relative

// Кастомный слайдер в темной теме
.custom-slider
  -webkit-appearance: none
  appearance: none
  width: 100%
  height: 8px
  background: #444951
  outline: none
  border-radius: 4px
  transition: background 0.3s

  // Thumb (ползунок) для Webkit
  &::-webkit-slider-thumb
    -webkit-appearance: none
    appearance: none
    width: 20px
    height: 20px
    background: #379392
    cursor: pointer
    border-radius: 50%
    transition: all 0.3s
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3)

    &:hover
      transform: scale(1.15)
      box-shadow: 0 3px 6px rgba(55, 147, 146, 0.5)

  // Thumb для Firefox
  &::-moz-range-thumb
    width: 20px
    height: 20px
    background: #379392
    cursor: pointer
    border-radius: 50%
    border: none
    transition: all 0.3s
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3)

    &:hover
      transform: scale(1.15)
      box-shadow: 0 3px 6px rgba(55, 147, 146, 0.5)

  // Track для Firefox
  &::-moz-range-track
    background: #444951
    border-radius: 4px
    height: 8px

// Подписи слайдера (1 и 365)
.slider-labels
  display: flex
  justify-content: space-between
  margin-top: 4px
  font-size: 12px
  color: #868e96

// Кастомный числовой input с большими кнопками
.custom-numeric-input
  display: flex
  align-items: center
  justify-content: center
  margin-top: 16px
  gap: 0

.control-btn
  width: 60px
  height: 60px
  background: #444951
  border: 1px solid #3d4148
  color: #979a9f
  font-size: 28px
  font-weight: 300
  cursor: pointer
  transition: all 0.2s
  display: flex
  align-items: center
  justify-content: center

  &:first-child
    border-radius: 8px 0 0 8px

  &:last-child
    border-radius: 0 8px 8px 0

  &:hover:not(:disabled)
    background: #868e96
    color: #fff

  &:disabled
    opacity: 0.4
    cursor: not-allowed

.days-input
  width: 120px
  height: 60px
  background: #2d3035
  border: 1px solid #3d4148
  border-left: none
  border-right: none
  color: #fff
  font-size: 32px
  font-weight: 300
  text-align: center
  padding: 0
  outline: none

  &:focus
    border-color: #379392
    box-shadow: inset 0 0 0 1px #379392

  // Скрыть стрелки у input type="number"
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0

  &[type=number]
    -moz-appearance: textfield

// Информация о ценах
.price-info
  margin-top: 32px

  .table
    margin-bottom: 12px
    border-collapse: separate
    border-spacing: 0

    tbody
      background: transparent

    tr
      &:first-child td
        border-top: none

    td
      border-top: 1px solid rgba(68, 73, 81, 0.3)
      color: #868e96
      padding: 12px 0
      font-size: 14px

      &:first-child
        padding-left: 0

      &:last-child
        padding-right: 0
        text-align: right
        color: #979a9f
        font-weight: 500

      strong
        color: #fff
        font-size: 15px

    tr:last-child td
      border-top: 2px solid #444951
      padding-top: 16px
      padding-bottom: 8px
      font-size: 16px

      &:last-child
        font-size: 24px
        color: #fff
        font-weight: 600

// Анимация финальной цены
.final-price-animated
  display: inline-block
  animation: priceChange 0.3s ease-out
  color: #379392
  font-weight: 700
  font-size: 20px

@keyframes priceChange
  0%
    opacity: 0.5
    transform: scale(0.95)
  50%
    opacity: 1
    transform: scale(1.05)
  100%
    opacity: 1
    transform: scale(1)

// Badge с экономией
.savings-badge-container
  display: flex
  justify-content: center
  margin-top: 12px

.savings-badge
  font-size: 13px
  padding: 6px 14px
  background: rgba(55, 147, 146, 0.15) !important
  color: #379392 !important
  border: 1px solid rgba(55, 147, 146, 0.3)
  border-radius: 20px
  font-weight: 500

@keyframes badgePulse
  0%, 100%
    transform: scale(1)
  50%
    transform: scale(1.05)
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.5)

// Модальное окно
.modal-dialog
  max-width: 600px

.modal-content
  background-color: #2d3035
  border: 1px solid #444951

.modal-header
  border-bottom: 1px solid #444951

  .modal-title
    color: #fff

  .close
    color: #979a9f
    opacity: 0.8

    &:hover
      opacity: 1
      color: #fff

.modal-body
  padding: 24px

.modal-footer
  border-top: 1px solid #444951
  display: flex
  flex-direction: column
  align-items: stretch
  padding: 24px

// Label для выбора способа оплаты
.payment-label
  font-weight: 600
  margin-bottom: 16px
  display: block
  color: #fff
  font-size: 15px

// Контейнер для методов оплаты
.payment-methods
  display: flex
  flex-direction: column
  gap: 12px
  margin-bottom: 20px

// Опция оплаты (radio button)
.payment-option
  position: relative
  display: flex
  align-items: center
  padding: 16px
  background: #2d3035
  border: 2px solid #444951
  border-radius: 8px
  cursor: pointer
  transition: all 0.2s

  &:hover
    border-color: #868e96

  &.selected
    border-color: #379392
    background: rgba(55, 147, 146, 0.05)

  input[type="radio"]
    position: absolute
    opacity: 0
    width: 0
    height: 0

.payment-content
  display: flex
  align-items: center
  gap: 12px
  width: 100%

.payment-flag
  width: 36px
  height: 36px
  min-width: 36px
  display: flex
  align-items: center
  justify-content: center
  font-size: 12px
  font-weight: 700
  border-radius: 6px
  color: #fff
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3)

  &.payment-flag-ru
    background: linear-gradient(to bottom, #fff 0%, #fff 33%, #0039a6 33%, #0039a6 66%, #d52b1e 66%, #d52b1e 100%)
    color: #0039a6
    text-shadow: none
    letter-spacing: 0.5px

  &.payment-flag-ww
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    box-shadow: 0 2px 6px rgba(102, 126, 234, 0.2)
    letter-spacing: 0.5px

.payment-text
  display: flex
  flex-direction: column
  gap: 2px

.payment-name
  color: #fff
  font-size: 16px
  font-weight: 500

.payment-desc
  color: #868e96
  font-size: 13px

// Кнопка оплаты
.btn-pay
  margin-top: 8px
  font-size: 16px
  font-weight: 600
  padding: 14px
</style>
